/* ExpInfoPrograms */

import { Grid, Box, Chip, Card, CardContent } from '@material-ui/core'
import Carousel from 'react-material-ui-carousel'
import CurrencyFormat from 'react-currency-format'
import Map from '../Map/Map'
import { createSelector } from 'reselect'
//HELPERS
import { embedYoutubeVideo, capitalizeFirstLetter } from '../../utils/helpers'

//COMPONENTS
import BookerForm from '../BookerForm/BookerForm'
import { useEffect, useState } from 'react'
import './styles.scss'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../utils/fontAwesome'
import {
  getExperienceById,
  getExperienceGallery,
} from '../../services/FirebaseServices/experienceServices'
import { makeSelectAgency } from '../../redux/ducks/experiences'
import { useSelector } from 'react-redux'
import { getAgencyById } from '../../services/FirebaseServices/agencyServices'
const stateSelector = createSelector([makeSelectAgency], (agency) => ({
  agency,
}))
const ExperienceInformationPrograms = ({
  singleExperience,
  gallery,
  // experiencesGallery,
  hotDeal,
}) => {
  const { agency } = useSelector(stateSelector)
  const [descriptionState, setDescriptionState] = useState(false)
  const [experiences, setExperiences] = useState(new Set())
  const [experiencesDataProgram, setExperiencesDataProgram] = useState([])
  const [showAllDays, setShowAllDays] = useState(false)
  const [imgsProgram, setImgsProgram] = useState()
  const concatImages = imgsProgram ? gallery.concat(imgsProgram) : gallery
  // const combinedGallery = [...gallery, ...imgsProgram]
  const finalImages = concatImages.filter((img) => img !== '')
  // gallery.concat(experiencesGallery)

  const fetchExperiences = async () => {
    const tempExperiencesData = []

    for (const id of experiences) {
      const experience = await getExperienceById(id)

      tempExperiencesData.push(experience)
    }

    setExperiencesDataProgram(tempExperiencesData)
  }

  const getActivities = async () => {
    const tempExperiences = new Set(experiences) // Copia el conjunto actual de experiencias

    singleExperience.activities.forEach((activity) => {
      if (activity.experiencesAM.id) {
        tempExperiences.add(activity.experiencesAM.id)
      }
      if (activity.experiencesPM.id) {
        tempExperiences.add(activity.experiencesPM.id)
      }
      if (activity.hotels.id) {
        tempExperiences.add(activity.hotels.id)
      }
    })

    setExperiences(tempExperiences)
  }

  useEffect(() => {
    getImagesOfProgramExperiences()
  }, [agency.key])

  useEffect(() => {
    getActivities()
  }, [singleExperience])

  useEffect(() => {
    fetchExperiences()
  }, [experiences])

  let description = singleExperience.binnacleStart
  const dayNumber = 1
  let shortDescription
  if (description.length > 1200) {
    let divideString = Math.floor(description.length / 2)
    shortDescription = description.substring(0, divideString)
  }
  const handleShowAllDays = () => {
    setShowAllDays(!showAllDays)
  }
  const handleDescription = (e) => {
    e.preventDefault()
    setDescriptionState(!descriptionState)
  }
  const handleCarousel = () => {
    const carouselArray = []

    carouselArray.push({
      type: 'video',
      title: singleExperience.name,
      link: singleExperience.linkVideo,
    })

    gallery.forEach((item) => carouselArray.push({ type: 'photo', link: item }))

    return carouselArray
  }

  const handleLocator = () => {
    if (singleExperience.locator) {
      return singleExperience.locator.formatted_address
        ? singleExperience.locator.formatted_address
        : singleExperience.locator
    }
  }

  const getImagesOfProgramExperiences = async () => {
    const imagesArray = []
    // const agencyResponse = await getAgencyById(agency.key)
    await Promise.all(
      singleExperience.activities.map(async (activity, index) => {
        if (
          activity.experiencesAM.id !== '' &&
          activity.experiencesAM.id !== null &&
          activity.experiencesAM.id !== undefined &&
          activity.experiencesPM.id !== '' &&
          activity.experiencesPM.id !== null &&
          activity.experiencesPM.id !== undefined &&
          activity.hotels.id !== '' &&
          activity.hotels.id !== null &&
          activity.hotels.id !== undefined
        ) {
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesAM.id),
          )
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesPM.id),
          )
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.hotels.id),
          )
        } else if (
          activity.experiencesAM.id !== '' &&
          activity.experiencesAM.id !== null &&
          activity.experiencesAM.id !== undefined &&
          activity.experiencesPM.id !== '' &&
          activity.experiencesPM.id !== null &&
          activity.experiencesPM.id !== undefined
        ) {
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesAM.id),
          )
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesPM.id),
          )
        } else if (
          activity.experiencesAM.id !== '' &&
          activity.experiencesAM.id !== null &&
          activity.experiencesAM.id !== undefined &&
          activity.hotels.id !== '' &&
          activity.hotels.id !== null &&
          activity.hotels.id !== undefined
        ) {
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesAM.id),
          )
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.hotels.id),
          )
        } else if (
          activity.experiencesPM.id !== '' &&
          activity.experiencesPM.id !== null &&
          activity.experiencesPM.id !== undefined &&
          activity.hotels.id !== '' &&
          activity.hotels.id !== null &&
          activity.hotels.id !== undefined
        ) {
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesPM.id),
          )
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.hotels.id),
          )
        } else if (
          activity.experiencesAM.id !== '' &&
          activity.experiencesAM.id !== null &&
          activity.experiencesAM.id !== undefined
        ) {
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesAM.id),
          )
        } else if (
          activity.experiencesPM.id !== '' &&
          activity.experiencesPM.id !== null &&
          activity.experiencesPM.id !== undefined
        ) {
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.experiencesPM.id),
          )
        } else if (
          activity.hotels.id !== '' &&
          activity.hotels.id !== null &&
          activity.hotels.id !== undefined
        ) {
          imagesArray.push(
            await getExperienceGallery(agency.key, activity.hotels.id),
          )
        }
      }),
    )
    const combinedArray = [].concat(...imagesArray)
    const uniqueImagesSet = new Set(combinedArray)
    const uniqueImagesArray = [...uniqueImagesSet]

    setImgsProgram(uniqueImagesArray)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        {singleExperience.linkVideo ? (
          <Carousel>
            {handleCarousel().map((item, index) => {
              if (item.type === 'video') {
                return (
                  <iframe
                    title={`exp-${item.title}`}
                    width="100%"
                    height="300px"
                    src={`//www.youtube.com/embed/${embedYoutubeVideo(
                      item.link,
                    )}`}
                    key={index}
                  />
                )
              } else {
                return (
                  <div
                    style={{
                      backgroundImage: `url(${item.link})`,
                      width: '100%',
                      height: '300px',
                      backgroundPosition: 'center center',
                      backgroundSize: 'cover',
                      borderRadius: '15px',
                    }}
                    key={index}
                  ></div>
                )
              }
            })}
          </Carousel>
        ) : (
          <Carousel>
            {imgsProgram
              ? finalImages.map((item, index) => {
                  return (
                    <LazyLoadImage
                      src={item}
                      className="imgCarousel"
                      key={index}
                      alt="img not found @heyandes"
                    />
                  )
                })
              : gallery.map((item, index) => {
                  return (
                    <LazyLoadImage
                      src={item}
                      className="imgCarousel"
                      key={index}
                      alt="img not found @heyandes"
                    />
                  )
                })}
          </Carousel>
        )}

        <div className="price">
          {singleExperience.type === 'PXQ' ||
          singleExperience.type === 'PXH' ? (
            <p>Desde</p>
          ) : null}
          <CurrencyFormat
            value={
              singleExperience.type === 'PXH'
                ? singleExperience?.pricePerHour[0]?.price
                : singleExperience.type === 'PXQ'
                ? singleExperience?.priceQuantity[0]?.price
                : singleExperience.valuePerPerson
            }
            displayType="text"
            thousandSeparator
            className="pricecard"
            prefix="$"
          />
          <span>{' por reserva'}</span>
        </div>
        <p>
          {!shortDescription
            ? capitalizeFirstLetter(description)
            : shortDescription.length > 0 && descriptionState === false
            ? capitalizeFirstLetter(shortDescription)
            : description && description.length > 0 && descriptionState === true
            ? capitalizeFirstLetter(description)
            : null}
        </p>
        <p className="btnDescription" onClick={handleDescription}>
          {!shortDescription
            ? ' '
            : descriptionState === false
            ? 'Ver más'
            : 'Ver menos'}
        </p>

        {!!singleExperience.equipmentRequired ||
        !!singleExperience.previousExperience ? (
          <hr className="hr-style" />
        ) : (
          ''
        )}

        {singleExperience.activities.length > 0 &&
          singleExperience.activities.map((activity, index) => (
            <div
              key={index}
              style={{ display: showAllDays || index === 0 ? 'block' : 'none' }}
            >
              <p className="day">Día {index + 1}</p>
              <div className="experiencesPerProgram">
                <p>
                  {activity.experiencesAM
                    ? `Por la mañana: ${
                        experiencesDataProgram.find(
                          (exp) => exp.key === activity.experiencesAM.id,
                        )?.name || 'No hay experiencia'
                      }`
                    : 'No hay experiencia de la mañana'}
                </p>
                <p>
                  {activity.experiencesPM
                    ? `Por la tarde: ${
                        experiencesDataProgram.find(
                          (exp) => exp.key === activity.experiencesPM.id,
                        )?.name || 'No hay experiencia'
                      }`
                    : 'No hay experiencia de la tarde'}
                </p>
                <p>
                  {activity.hotels
                    ? `Alojamiento por la noche en: ${
                        experiencesDataProgram.find(
                          (exp) => exp.key === activity.hotels.id,
                        )?.name || 'Alojamiento no encontrado'
                      }`
                    : 'No incluye alojamiento'}
                </p>
              </div>
              {typeof activity.activities === 'object' &&
              activity.activities.extraActivity !== false ? (
                <div className="extras">
                  <span>
                    <p>Actividad extra: {activity.activities.title}</p>
                    <p>{activity.activities.description}</p>
                    <p>Hora: {activity.activities.hour}</p>
                    <p>Ubicación: {activity.activities.locator}</p>
                    <p>Precio: {activity.activities.price}</p>
                  </span>
                </div>
              ) : (
                <p>No hay actividades extras para el día {index + 1}.</p>
              )}
            </div>
          ))}
        {showAllDays ? (
          <p className="btnDescription" onClick={handleShowAllDays}>
            Ver menos
          </p>
        ) : (
          <p className="btnDescription" onClick={handleShowAllDays}>
            Ver más
          </p>
        )}

        <Grid container spacing={2}>
          {singleExperience.included?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Incluye</h4>
                {singleExperience.included.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}

          {singleExperience.notIncluded?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>No Incluye</h4>
                {singleExperience.notIncluded.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}

          {singleExperience.includedFeatured?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Incluye Destacado</h4>
                {singleExperience.includedFeatured.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio.included)}
                      key={servicio.included}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}

          {singleExperience.rules?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Reglas</h4>
                {singleExperience.rules.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}
          {singleExperience.healtAndSecurity?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Salud y Seguridad</h4>
                {singleExperience.healtAndSecurity.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}

          {singleExperience.rulesCancelation?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Políticas de Cancelación</h4>
                {singleExperience.rulesCancelation.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}

          {!!singleExperience.equipmentRequired?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Equipamiento requerido</h4>
                {singleExperience.equipmentRequired.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}
          {!!singleExperience.previousExperience?.length > 0 ? (
            <Grid item xs={12} md={12}>
              <Box>
                <h4>Experiencia requerida</h4>
                {singleExperience.previousExperience.map((servicio) => {
                  return (
                    <Chip
                      className="chip"
                      color="primary"
                      size="small"
                      label={capitalizeFirstLetter(servicio)}
                      key={servicio}
                    />
                  )
                })}
              </Box>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <BookerForm type={singleExperience.category} hotDeal={hotDeal} />
      </Grid>

      {!!singleExperience.locator ? (
        <>
          <Grid item md={12} xs={12}>
            <hr className="hr-style" />
            <Card style={{ marginTop: '25px' }}>
              <CardContent>
                {handleLocator() && (
                  <p style={{ margin: '15px 0' }}>
                    <span style={{ fontWeight: 'bold' }}>Ubicacion: </span>{' '}
                    {handleLocator()}{' '}
                  </p>
                )}
                {!!singleExperience.locator ? (
                  <>
                    <Map experience={singleExperience} />
                  </>
                ) : (
                  ''
                )}
              </CardContent>
            </Card>
          </Grid>
        </>
      ) : (
        ''
      )}
    </Grid>
  )
}

export default ExperienceInformationPrograms
